import { useMemo } from 'react';

import type { CommunityProfile, CommunityProfileLinks } from '~/api/community/types';

export const linkIcons = {
  website: 'Globe',
  linkedIn: 'LinkedIn',
  instagram: 'Instagram',
  facebook: 'Facebook',
  behance: 'Behance',
} as const;

type LinkType = keyof typeof linkIcons;

export const useCommunityProfileLinks = (links: CommunityProfileLinks) =>
  useMemo(
    () =>
      [
        { type: 'website' as const, url: links.website },
        { type: 'linkedIn' as const, url: links.linkedIn },
        { type: 'instagram' as const, url: links.instagram },
        { type: 'facebook' as const, url: links.facebook },
        { type: 'behance' as const, url: links.behance },
      ].filter((link): link is { type: LinkType; url: string } => !!link.url),
    [links],
  );

export const getCommunityProfileNames = (profile: Pick<CommunityProfile, 'brand' | 'firstName' | 'lastName'>) => {
  const fullName = `${profile.firstName} ${profile.lastName}`;

  if (!profile.brand) return { fullName: null, name: fullName };

  // Some freelancers use their own name as brand, so the full name is only returned when it differs.
  const isSameName = profile.brand.localeCompare(fullName, undefined, { sensitivity: 'base' }) === 0;

  return { fullName: isSameName ? null : fullName, name: profile.brand };
};
